import { Component, Input, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of, defer } from 'rxjs';
import { scan } from 'rxjs/operators';
import { DialogComponent } from '@app/can-leave/components/dialog/dialog.component';
import { CanLeaveService } from '@app/core/services/can-leave.service';

/** Extends the DialogComponent to popup during CanDeactivate*/
@Component({
  selector: 'ecp-can-leave',
  template: '<ng-template><ng-content></ng-content></ng-template>',
})
export class CanLeaveComponent extends DialogComponent<boolean> {
  constructor(private canLeave: CanLeaveService, dialog: MatDialog) {
    super(dialog);

    // Hooks on the allowDeactivation observer
    this.canLeave.allowDeactivation(this.canLeave$);
  }

  /** When true, pops-up a dialog asking for user's consent to leave*/
  @Input() dontLeave = false;

  // CanLeave Observavble
  private get canLeave$(): Observable<boolean> {
    // Builds an observable conditionally at subscription time
    return (
      defer(() => (this.dontLeave ? this.open().afterClosed() : of(true)))
        // Makes sure all the following requests will be true once the first has been granted
        .pipe(scan((granted, allow) => granted || allow, false))
    );
  }
}
